import {
  normalizeHeaderFooterTypographySettings,
  type HeaderFooterTypographySettings,
} from '../settings/header-footer-typography.schema';
import {
  buildTypographyInlineDeclarationString,
  buildTypographyRule,
} from './typography-css';

export function buildStorefrontHeaderTypographyCss(input: unknown): string {
  const typography = normalizeHeaderFooterTypographySettings(input);
  return [
    buildTypographyRule(
      '.storefront-top-bar, .storefront-top-bar__link',
      typography.topBarText,
    ),
    buildTypographyRule('.navbar-brand, .navbar-brand-label', typography.brandTitle),
    buildTypographyRule('.navbar-nav .nav-link', typography.headerMenuRoot),
    buildTypographyRule('.navbar-nav-mobile > .nav-link', typography.headerMenuRoot),
    buildTypographyRule('.nav-mobile-group > .nav-link', typography.headerMenuRoot),
    buildTypographyRule('.nav-dropdown-item', typography.headerMenuChild),
    buildTypographyRule('.nav-link-child', typography.headerMenuChild),
    buildTypographyRule(
      '.navbar-search .form-input, .navbar-search .form-input::placeholder, .universal-search__form .form-input, .universal-search__form .form-input::placeholder',
      typography.headerSearchText,
    ),
    buildTypographyRule('.user-menu-trigger', typography.headerAccountLabel),
    buildTypographyRule('.cart-button', typography.headerCartAction),
  ]
    .filter(Boolean)
    .join('\n');
}

export function buildTopBarTypographyInlineStyle(
  typography: HeaderFooterTypographySettings,
): string {
  return buildTypographyInlineDeclarationString(typography.topBarText);
}

export function buildBrandTitleTypographyInlineStyle(
  typography: HeaderFooterTypographySettings,
): string {
  return buildTypographyInlineDeclarationString(typography.brandTitle);
}

export function mergeHtmlStyleAttributes(...parts: string[]): string {
  const merged = parts.map((part) => part.trim()).filter(Boolean).join(';');
  return merged ? ` style="${merged}"` : '';
}
